import { render, staticRenderFns } from "./UserAbout.vue?vue&type=template&id=7c25f12c&scoped=true&"
import script from "./UserAbout.vue?vue&type=script&lang=js&"
export * from "./UserAbout.vue?vue&type=script&lang=js&"
import style0 from "./UserAbout.vue?vue&type=style&index=0&id=7c25f12c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c25f12c",
  null
  
)

export default component.exports